export const TDS_RESULT = '3DS_RESULT';
export const TDS_RESULT_SUCCESS = 'complete';
export const TDS_RESULT_FAILED = 'failed';
export const ThreeDSEventDiscriminators = {
  TDS_RESULT
};
